import theme from "styled-theming";
import styled from "styled-components";
import {Link} from "react-router-dom";
import {Navbar, NavLink} from "react-bootstrap";
import {FaUserAlt} from "react-icons/fa";
import {Button} from "react-bootstrap";
import Table from "../Utility/Table";

// theme styles

export const backgroundColor = theme("mode", {
  light: "#ffffff",
  dark: "#1a1a1a",
});
export const textColor = theme("mode", {
  light: "#1a1a1a",
  dark: "#ffffff",
});

export const buttonBackgroundColor = theme("mode", {
  light: "#1a1a1a",
  dark: "#ffffff",
});
export const buttonTextColor = theme("mode", {
  light: "#ffffff",
  dark: "#1a1a1a",
});

export const navBackgroundColor = theme("mode", {
  light: "#ffffff",
  dark: "#1a1a1a",
});

export const navBoxShadow = theme("mode", {
  light: "0 0 10px;",
  dark: "0 0 0px;",
});

export const navTextColor = theme("mode", {
  light: "#1a1a1a",
  dark: "#ffffff",
});

export const navItemBackgroundColor = theme("mode", {
  light: "#ffffff",
  dark: "#1a1a1a",
});

export const ActiveNavItemBackgroundColor = theme("mode", {
  light: "#eee",
  dark: "#eee",
});

export const HoverNavItemBackgroundColor = theme("mode", {
  light: "#eee",
  dark: "#000000",
});

export const navItemTextColor = theme("mode", {
  light: "#1a1a1a",
  dark: "#ffffff",
});

export const oddTableItemBackgroundColor = theme("mode", {
  light: "rgba(0, 0, 0, 0.05)",
  dark: "rgba(255, 255, 255, 0.05)",
});

export const oddTableItemHoverBackgroundColor = theme("mode", {
  light: "rgba(0, 0, 0, 0.075)",
  dark: "rgba(255, 255, 255, 0.075)",
});

export const oddTableItemHoverColor = theme("mode", {
  light: "#1a1a1a",
  dark: "#ffffff",
});

export const tableHeaderRow = theme("mode", {
  light: "#1a1a1a",
  dark: "#ffffff",
});


// styled components

export const StyledUserIcon = styled(FaUserAlt)`
  background: ${backgroundColor};
  color: ${textColor};
`;

export const StyledNavItem = styled(NavLink)`
  background: ${navItemBackgroundColor};
  color: ${navItemTextColor};
  padding: 0.9rem 1rem;
  position: relative;
  display: block;
  &:hover {
    color: ${navItemTextColor};
    background: ${HoverNavItemBackgroundColor};
  }
  &:active {
    color: ${navItemTextColor};
    background: ${ActiveNavItemBackgroundColor};
  }
  &.active{
    color: ${navItemTextColor};
    background: ${ActiveNavItemBackgroundColor};
  }
`;

export const StyledNavBar = styled(Navbar)`
  background: ${navBackgroundColor};
  color: ${navTextColor};
  box-shadow: ${navBoxShadow};
  padding: 0rem 1rem;
`;

export const ThemedView = styled.div`
  .breadcrumb-item.clickable a {
    color: ${textColor};
    &:hover,
    &:active {
      color: ${textColor};
    }
  }
  .table {
    color: ${textColor};
  }
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: ${oddTableItemBackgroundColor};
  }
  .table-hover tbody tr:hover {
    background-color: ${oddTableItemHoverBackgroundColor};
    color: ${oddTableItemHoverColor};
  }
  .editable-text-input {
    input.form-control {
      color: ${textColor};
      background: ${backgroundColor};
      border-color: ${textColor};
      &:focus,
      &:active,
      &:focus:active {
        color: ${textColor};
        background: ${backgroundColor};
        border-color: ${textColor};
      }
    }
  }
`;
